module.exports = __webpack_public_path__ + "static/media/title-dresscode.16a55a52.png";